import React from 'react';
import { connectSearchBox } from 'react-instantsearch/connectors';

import styled from 'styled-components';
import { colors } from '../../shared/styles';

const SearchSection = styled.div`
    position: relative;

    > div {
        background: #fff;
        overflow: hidden;
        height: 46px;
        border-radius: 4px;
        border: solid 1px ${colors.grey.light};
    }

    label {
        font-size: 12px;
        font-weight: bold;
        line-height: 1.4;
        width: 178px;
        height: 32px;
        color: rgba(0, 0, 0, 0.4);
        position: absolute;
        top: 20px;
        left: 20px;
        padding: 7px 0 7px 46px;
        z-index: 1;
        display: none;

        &.is-visible {
            display: block;
        }
    }

    input {
        border-radius: 4px;
        background: none;
        border: 0;
        appearance: none;
        display: inline-block;
        transition: box-shadow .4s ease, background .4s ease;
        border-radius: 4px;
        box-shadow: 0 1px 1px 0 rgba(85, 95, 110, 0.2);
        padding: 0;
        padding-right: 36px;
        padding-left: 46px;
        width: 100%;
        height: 100%;
        vertical-align: middle;
        white-space: normal;
        font-size: inherit;
        box-sizing: border-box;
        outline: 0;
        position: relative;
        z-index: 2;

        &:valid ~ button[type="reset"] {
            display: block;
        }
    }

    button {
        &[type="submit"] {
            position: absolute;
            top: 0;
            z-index: 3;
            right: inherit;
            left: 20px;
            margin: 0;
            border: 0;
            border-radius: 4px 0 0 4px;
            background-color: rgba(255, 255, 255, 0);
            padding: 0;
            width: 46px;
            height: 100%;
            vertical-align: middle;
            text-align: center;
            font-size: inherit;
            user-select: none;

            svg {
                width: 18px;
                height: 18px;
                vertical-align: middle;
                fill: #bfc7d8;
            }
        }

        &[type="reset"] {
            display: none;
            position: absolute;
            top: 33px;
            z-index: 3;
            right: 33px;
            margin: 0;
            border: 0;
            background: none;
            cursor: pointer;
            padding: 0;
            font-size: inherit;
            user-select: none;
            fill: #bfc7d8;

            svg {
                display: block;
                margin: 4px;
                width: 12px;
                height: 12px;
            }
        }
    }
`;

const SVGSyles = {
    display: 'none',
};

const PropertySearchBox = ({ currentRefinement, refine }) => {
    const labelIsVisible = !currentRefinement ? 'is-visible' : '';

    return (
        <SearchSection className="search-section">
            <svg xmlns="http://www.w3.org/2000/svg" style={SVGSyles}>
                <symbol
                    xmlns="http://www.w3.org/2000/svg"
                    id="sbx-icon-search-13"
                    viewBox="0 0 40 40"
                >
                    <path
                        d="M26.804 29.01c-2.832 2.34-6.465 3.746-10.426 3.746C7.333 32.756 0 25.424 0 16.378 0 7.333 7.333 0 16.378 0c9.046 0 16.378 7.333 16.378 16.378 0 3.96-1.406 7.594-3.746 10.426l10.534 10.534c.607.607.61 1.59-.004 2.202-.61.61-1.597.61-2.202.004L26.804 29.01zm-10.426.627c7.323 0 13.26-5.936 13.26-13.26 0-7.32-5.937-13.257-13.26-13.257C9.056 3.12 3.12 9.056 3.12 16.378c0 7.323 5.936 13.26 13.258 13.26z"
                        fillRule="evenodd"
                    />
                </symbol>
                <symbol
                    xmlns="http://www.w3.org/2000/svg"
                    id="sbx-icon-clear-3"
                    viewBox="0 0 20 20"
                >
                    <path
                        d="M8.114 10L.944 2.83 0 1.885 1.886 0l.943.943L10 8.113l7.17-7.17.944-.943L20 1.886l-.943.943-7.17 7.17 7.17 7.17.943.944L18.114 20l-.943-.943-7.17-7.17-7.17 7.17-.944.943L0 18.114l.943-.943L8.113 10z"
                        fillRule="evenodd"
                    />
                </symbol>
            </svg>
            <div>
                <label className={labelIsVisible}>
                    Location, postcode, nearest station or reference no...
                </label>

                <input
                    type="text"
                    value={currentRefinement}
                    onChange={e => refine(e.target.value)}
                    required
                />
                <button type="submit">
                    <svg role="img" width="1em" height="1em">
                        <use xlinkHref="#sbx-icon-search-13" />
                    </svg>
                </button>
                <button type="reset" onClick={e => refine()}>
                    <svg role="img" width="1em" height="1em">
                        <use xlinkHref="#sbx-icon-clear-3" />
                    </svg>
                </button>
            </div>
        </SearchSection>
    );
};

export default connectSearchBox(PropertySearchBox);



// WEBPACK FOOTER //
// ./src/containers/PropertySearch/PropertySearchBox.js